const button = {
    cancel: 'Cancel',
    ok: 'OK',

    no: 'No',
    yes: 'Yes',
};

export default button;
